/* Size Engine - interactive size finder. Pure recommend() + DOM controller. */
(function () {
  'use strict';

  var LS_KEY = 'jrsSizeGuide.v1';

  function parseRange(s) {
    if (s === null || s === undefined) return [NaN, NaN];
    var str = String(s).trim();
    var parts = str.split('-');
    if (parts.length >= 2) {
      return [parseFloat(parts[0]), parseFloat(parts[1])];
    }
    var n = parseFloat(str);
    return [n, n];
  }

  /* Pure recommendation engine. inputs: {height, weight, age, fit}. */
  function recommend(data, cat, inputs) {
    var catData = data.categories[cat];
    var sizes = catData.sizes;
    var last = sizes.length - 1;
    var height = inputs.height;
    var weight = inputs.weight;
    var age = inputs.age;
    var fit = inputs.fit || 'regular';
    var notes = [];
    var clamp = null;
    var boundary = false;
    var conf = 'high';
    var idx = -1;
    var i;

    // Step 1: height candidates
    var matches = [];
    for (i = 0; i < sizes.length; i++) {
      var hr = parseRange(sizes[i].height);
      if (height >= hr[0] && height <= hr[1]) matches.push(i);
    }
    if (matches.length === 0) {
      var firstH = parseRange(sizes[0].height);
      if (height < firstH[0]) {
        idx = 0;
        clamp = 'below';
      } else {
        idx = last;
        clamp = 'above';
      }
    } else if (matches.length > 1) {
      // Height bands overlap (NBA, 10cm) or share endpoints (men/winter), so several
      // sizes can match. For adult categories weight decides between the candidates;
      // "largest wins" only when weight can't decide.
      idx = matches[matches.length - 1];
      boundary = true;
      if (cat !== 'kids' && !isNaN(weight)) {
        var wMatches = [];
        for (i = 0; i < matches.length; i++) {
          var cwr = parseRange(sizes[matches[i]].weight);
          if (weight >= cwr[0] && weight <= cwr[1]) wMatches.push(matches[i]);
        }
        if (wMatches.length) {
          idx = wMatches[wMatches.length - 1];
          boundary = wMatches.length > 1;
        } else if (weight < parseRange(sizes[matches[0]].weight)[0]) {
          idx = matches[0];
          boundary = false;
        } else {
          // weight above every candidate: keep largest, the step-up note explains
          boundary = false;
        }
      }
    } else {
      idx = matches[0];
    }

    if (cat === 'kids') {
      // Step 2: kids branch (age + height, larger wins). No weight, no player.
      var ageMatches = [];
      for (i = 0; i < sizes.length; i++) {
        var ar = parseRange(sizes[i].age);
        if (age >= ar[0] && age <= ar[1]) ageMatches.push(i);
      }
      var ageIdx;
      if (ageMatches.length === 0) {
        var firstA = parseRange(sizes[0].age);
        ageIdx = (age < firstA[0]) ? 0 : last;
      } else {
        ageIdx = ageMatches[ageMatches.length - 1];
      }
      if (ageIdx > idx) {
        idx = ageIdx;
        conf = 'medium';
        notes.push('לפי הגיל והגובה יחד בחרנו את המידה הגדולה מביניהם');
      } else if (ageIdx === idx) {
        conf = 'high';
      } else {
        conf = 'medium';
        notes.push('לפי הגיל והגובה יחד בחרנו את המידה הגדולה מביניהם');
      }
    } else {
      // Step 3: weight refinement
      var wr = parseRange(sizes[idx].weight);
      if (weight >= wr[0] && weight <= wr[1]) {
        conf = 'high';
      } else if (weight > wr[1]) {
        var steps = 0;
        while (idx < last && weight > parseRange(sizes[idx].weight)[1]) {
          idx++;
          steps++;
        }
        if (steps === 0) {
          // already at the largest size, nothing to step up to
          conf = 'low';
          notes.push('המשקל שהזנתם מעל טווח הטבלה, מומלץ להתייעץ איתנו בוואטסאפ');
        } else {
          conf = steps <= 1 ? 'medium' : 'low';
          notes.push('בהתאם למשקל שהזנתם עלינו מידה למעלה');
        }
      } else {
        conf = 'medium';
      }
      // Step 4: player fit
      if (fit === 'player') {
        if (idx < last) {
          idx++;
          notes.push('גרסת שחקן בגזרה צמודה, לכן המלצנו מידה אחת למעלה');
        } else {
          notes.push('גרסת שחקן בגזרה צמודה. אתם כבר במידה הגדולה ביותר, מומלץ להתייעץ איתנו בוואטסאפ');
        }
      }
    }

    // Step 5: overrides
    if (clamp) {
      conf = 'low';
      if (clamp === 'below') {
        notes.push('הנתונים שהזנתם מתחת לטווח הטבלה, לכן המלצנו על המידה הקטנה ביותר. לייעוץ אישי דברו איתנו בוואטסאפ');
      } else {
        notes.push('הנתונים שהזנתם מעל טווח הטבלה, לכן המלצנו על המידה הגדולה ביותר. לייעוץ אישי דברו איתנו בוואטסאפ');
      }
    } else if (boundary) {
      notes.push('הייתם בדיוק בין שתי מידות, לכן בחרנו עבורכם את הגדולה יותר');
    }

    return {
      size: sizes[idx].size,
      index: idx,
      conf: conf,
      notes: notes,
      clamp: clamp,
      boundary: boundary
    };
  }

  /* ── DOM helpers ── */
  function escapeHtml(s) {
    if (s === null || s === undefined) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sg-root]');
    for (var i = 0; i < roots.length; i++) {
      try { initInstance(roots[i]); } catch (e) { /* keep other instances alive */ }
    }
  }

  function initInstance(root) {
    var dataEl = root.querySelector('[data-sg-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var ctx = root.getAttribute('data-sg-context') || 'page';
    var category = root.getAttribute('data-sg-category') || 'men';
    var allowSwitch = category === 'all';
    var activeCat = allowSwitch ? 'men' : category;

    root.classList.add('sg--enhanced');
    if (ctx === 'modal') {
      var shell = root.closest('.size-guide-modal');
      if (shell) shell.classList.add('sg-sheet');
    }

    var els = {
      seg: root.querySelector('[data-sg-seg]'),
      ind: root.querySelector('[data-sg-ind]'),
      result: root.querySelector('[data-sg-result]'),
      sizeEl: root.querySelector('[data-sg-size]'),
      conf: root.querySelector('[data-sg-conf]'),
      confText: root.querySelector('[data-sg-conf-text]'),
      specs: root.querySelector('[data-sg-specs]'),
      notes: root.querySelector('[data-sg-notes]'),
      calc: root.querySelector('[data-sg-calc]'),
      apply: root.querySelector('[data-sg-apply]'),
      applySize: root.querySelector('[data-sg-apply-size]'),
      applyMissing: root.querySelector('[data-sg-apply-missing]')
    };
    var indRaf = null;

    function q(sel) { return root.querySelector(sel); }
    function getNum(name) {
      var el = q('[data-sg-num="' + name + '"]');
      if (!el) return NaN;
      return parseFloat(el.value);
    }
    function setFill(rng) {
      if (!rng) return;
      var min = parseFloat(rng.min), max = parseFloat(rng.max), v = parseFloat(rng.value);
      var pct = (max === min) ? 0 : ((v - min) / (max - min)) * 100;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      rng.style.setProperty('--sg-fill', pct + '%');
    }
    function updateFills() {
      var rs = root.querySelectorAll('[data-sg-range]');
      for (var i = 0; i < rs.length; i++) setFill(rs[i]);
    }

    function wireRanges() {
      var ranges = root.querySelectorAll('[data-sg-range]');
      for (var i = 0; i < ranges.length; i++) {
        (function (rng) {
          var name = rng.getAttribute('data-sg-range');
          var num = q('[data-sg-num="' + name + '"]');
          rng.addEventListener('input', function () {
            if (num) num.value = rng.value;
            setFill(rng);
          });
          if (num) {
            num.addEventListener('input', function () {
              var v = parseFloat(num.value);
              if (!isNaN(v)) { rng.value = v; setFill(rng); }
            });
            num.addEventListener('change', function () {
              var v = parseFloat(num.value);
              var mn = parseFloat(rng.min), mx = parseFloat(rng.max);
              if (isNaN(v)) v = mn;
              if (v < mn) v = mn;
              if (v > mx) v = mx;
              num.value = v; rng.value = v; setFill(rng);
            });
          }
        })(ranges[i]);
      }
    }

    function wireSteppers() {
      var steps = root.querySelectorAll('[data-sg-step]');
      for (var i = 0; i < steps.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var delta = parseInt(btn.getAttribute('data-sg-step'), 10) || 0;
            var num = q('[data-sg-num="age"]');
            var rng = q('[data-sg-range="age"]');
            if (!num) return;
            var mn = rng ? parseFloat(rng.min) : 2;
            var mx = rng ? parseFloat(rng.max) : 13;
            var v = parseFloat(num.value);
            if (isNaN(v)) v = mn;
            v += delta;
            if (v < mn) v = mn;
            if (v > mx) v = mx;
            num.value = v;
            if (rng) { rng.value = v; setFill(rng); }
          });
        })(steps[i]);
      }
    }

    function setFit(val) {
      var btns = root.querySelectorAll('[data-sg-fit]');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-sg-fit') === val;
        if (on) { btns[i].classList.add('is-active'); } else { btns[i].classList.remove('is-active'); }
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
    function getFit() {
      var a = q('[data-sg-fit].is-active');
      return a ? a.getAttribute('data-sg-fit') : 'regular';
    }
    function wireFit() {
      var btns = root.querySelectorAll('[data-sg-fit]');
      for (var i = 0; i < btns.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            setFit(btn.getAttribute('data-sg-fit'));
          });
        })(btns[i]);
      }
    }

    function toggleField(name, show) {
      var f = q('[data-sg-field="' + name + '"]');
      if (f) f.hidden = !show;
    }
    function setLimit(name, mn, mx, def) {
      var rng = q('[data-sg-range="' + name + '"]');
      var num = q('[data-sg-num="' + name + '"]');
      if (rng) {
        // Read before touching min/max: a range input clamps its value the moment
        // max shrinks, which would make 175 look like an in-range 165.
        var v = parseFloat(rng.value);
        rng.min = mn; rng.max = mx;
        // A value from another category that falls outside the new range (men 175 -> kids,
        // kids 130 -> NBA) resets to this category's default; clamping to the edge left an
        // 8-year-old at 165cm and a men's tab at 165 after a round trip through kids.
        if (isNaN(v) || v < mn || v > mx) v = (def !== undefined) ? def : (v < mn ? mn : mx);
        if (v < mn) v = mn;
        if (v > mx) v = mx;
        rng.value = v;
        setFill(rng);
      }
      if (num) {
        num.min = mn; num.max = mx;
        if (rng) num.value = rng.value;
      }
    }

    function applyCategory(cat) {
      var cd = data.categories[cat];
      if (!cd) return;
      var isKids = cat === 'kids';
      toggleField('weight', !isKids);
      toggleField('age', isKids);
      var fitWrap = q('[data-sg-fit-wrap]');
      if (fitWrap) fitWrap.hidden = cat !== 'men';
      // fit toggle only applies to men; reset to regular for other categories
      if (cat !== 'men') setFit('regular');
      var lim = cd.limits || {};
      if (lim.height) setLimit('height', lim.height[0], lim.height[1], isKids ? 130 : 175);
      if (isKids && lim.age) setLimit('age', lim.age[0], lim.age[1], 8);
      if (!isKids && lim.weight) setLimit('weight', lim.weight[0], lim.weight[1], 75);
      var panels = root.querySelectorAll('[data-sg-panel]');
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-sg-panel') !== cat;
      }
    }

    function positionInd() {
      if (!els.seg || !els.ind) return;
      var active = els.seg.querySelector('[data-sg-cat].is-active');
      if (!active) return;
      var cont = els.seg.getBoundingClientRect();
      var b = active.getBoundingClientRect();
      if (!b.width) return;
      els.ind.style.width = b.width + 'px';
      els.ind.style.transform = 'translateX(' + (b.left - cont.left) + 'px)';
    }
    function debounceInd() {
      if (indRaf) cancelAnimationFrame(indRaf);
      indRaf = requestAnimationFrame(positionInd);
    }

    function wireSeg() {
      if (!allowSwitch || !els.seg) return;
      var btns = els.seg.querySelectorAll('[data-sg-cat]');
      for (var i = 0; i < btns.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            activeCat = btn.getAttribute('data-sg-cat');
            for (var j = 0; j < btns.length; j++) {
              btns[j].classList.remove('is-active');
              btns[j].setAttribute('aria-selected', 'false');
            }
            btn.classList.add('is-active');
            btn.setAttribute('aria-selected', 'true');
            positionInd();
            applyCategory(activeCat);
            hideResult();
          });
        })(btns[i]);
      }
      window.addEventListener('resize', debounceInd);
    }

    function buildCards() {
      var wraps = root.querySelectorAll('[data-sg-cards]');
      for (var i = 0; i < wraps.length; i++) {
        var cat = wraps[i].getAttribute('data-sg-cards');
        var cd = data.categories[cat];
        if (!cd) continue;
        var html = '';
        for (var s = 0; s < cd.sizes.length; s++) {
          var row = cd.sizes[s];
          html += '<div class="sg__card" data-sg-card="' + escapeAttr(row.size) + '">';
          html += '<div class="sg__card-chip">מומלץ עבורכם</div>';
          html += '<div class="sg__card-size">' + escapeHtml(row.size) + '</div>';
          for (var c = 1; c < cd.columns.length; c++) {
            var col = cd.columns[c];
            html += '<div class="sg__card-row"><span class="sg__card-lbl">' + escapeHtml(col.label) +
              '</span><bdi class="sg__card-val">' + escapeHtml(row[col.key]) + '</bdi></div>';
          }
          html += '</div>';
        }
        wraps[i].innerHTML = html;
      }
    }

    function applyChip(kind, cd, recRow) {
      var chip = q('[data-sg-chip="' + kind + '"]');
      var valEl = q('[data-sg-dim="' + kind + '"]');
      var activeSil = q('[data-sg-sil="' + cd.silhouette + '"]');
      var dimline = activeSil ? activeSil.querySelector('[data-sg-dimline="' + kind + '"]') : null;
      var colKey = cd.dims ? cd.dims[kind] : null;
      var val = (colKey && recRow[colKey] !== undefined) ? recRow[colKey] : null;
      if (val !== null && val !== '') {
        if (valEl) valEl.textContent = val;
        if (chip) chip.hidden = false;
        if (dimline) dimline.style.display = '';
      } else {
        if (chip) chip.hidden = true;
        if (dimline) dimline.style.display = 'none';
      }
    }

    function renderSpecs(cd, recRow) {
      if (!els.specs) return;
      var html = '';
      for (var i = 0; i < cd.columns.length; i++) {
        var col = cd.columns[i];
        if (col.key === 'size') continue;
        html += '<span class="sg__spec"><span class="sg__spec-label">' + escapeHtml(col.label) +
          '</span><bdi class="sg__spec-val">' + escapeHtml(recRow[col.key]) + '</bdi></span>';
      }
      els.specs.innerHTML = html;
    }

    function renderNotes(res) {
      if (!els.notes) return;
      var html = '';
      var addWa = res.conf === 'low';
      for (var i = 0; i < res.notes.length; i++) {
        var n = res.notes[i];
        html += '<div class="sg__note">' + escapeHtml(n) + '</div>';
        if (n.indexOf('וואטסאפ') !== -1) addWa = true;
      }
      if (addWa) {
        html += '<a class="sg__wa-link" href="' + escapeAttr(data.whatsapp) +
          '" target="_blank" rel="noopener">דברו איתנו בוואטסאפ</a>';
      }
      els.notes.innerHTML = html;
    }

    function reveal() {
      if (!els.result) return;
      els.result.classList.remove('sg__result--in');
      els.result.hidden = false;
      // force reflow so the transition (re)runs on every calc
      void els.result.offsetWidth;
      els.result.classList.add('sg__result--in');
      var rect = els.result.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (rect.bottom > vh) {
        try {
          els.result.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'nearest' });
        } catch (e) {
          els.result.scrollIntoView();
        }
      }
    }
    function hideResult() {
      if (!els.result) return;
      els.result.classList.remove('sg__result--in');
      els.result.hidden = true;
      var recs = root.querySelectorAll('.sg-row--rec, .sg__card--rec');
      for (var i = 0; i < recs.length; i++) recs[i].classList.remove('sg-row--rec', 'sg__card--rec');
    }

    function highlightTable(cat, size) {
      var panel = q('[data-sg-panel="' + cat + '"]');
      if (!panel) return;
      var rows = panel.querySelectorAll('[data-sg-size-row]');
      for (var i = 0; i < rows.length; i++) rows[i].classList.remove('sg-row--rec');
      var rec = panel.querySelector('[data-sg-size-row="' + size + '"]');
      if (rec) rec.classList.add('sg-row--rec');
    }
    function highlightCards(cat, size) {
      var wrap = q('[data-sg-cards="' + cat + '"]');
      if (!wrap) return;
      var cards = wrap.querySelectorAll('[data-sg-card]');
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('sg__card--rec');
      var rec = wrap.querySelector('[data-sg-card="' + size + '"]');
      if (rec) {
        rec.classList.add('sg__card--rec');
        if (wrap.offsetParent !== null) {
          try { rec.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) { /* ignore */ }
        }
      }
    }

    function handleApply(res) {
      if (!els.apply) return;
      var selector = document.querySelector('.size-selector[data-option-index="0"]');
      var rec = res.size;
      var aliases;
      if (rec === 'XXL') aliases = ['XXL', '2XL'];
      else if (rec === '2XL') aliases = ['2XL', 'XXL'];
      else aliases = [rec];
      var found = null;
      if (selector) {
        for (var i = 0; i < aliases.length; i++) {
          var b = selector.querySelector('button[data-value="' + aliases[i] + '"]');
          if (b) { found = b; break; }
        }
        if (!found) {
          // fallback: match the leading token, e.g. data-value="22 (גיל 7-8)" matches rec "22"
          var btns = selector.querySelectorAll('button[data-value]');
          outer:
          for (var j = 0; j < btns.length; j++) {
            var tok = (btns[j].getAttribute('data-value') || '').trim().split(/[\s(]/)[0];
            for (var k = 0; k < aliases.length; k++) {
              if (tok === aliases[k]) { found = btns[j]; break outer; }
            }
          }
        }
      }
      if (found) {
        if (els.applyMissing) els.applyMissing.hidden = true;
        els.apply.hidden = false;
        if (els.applySize) els.applySize.textContent = rec;
        els.apply.onclick = function () {
          found.click();
          // 6.8.26: the modal now owns a `hidden` attribute, a body scroll lock and focus
          // restoration, so it must be closed through its own API. Removing .active alone
          // left the page scroll-locked after applying a recommended size.
          if (window.closeSizeGuideModal) {
            window.closeSizeGuideModal();
          } else {
            var modal = document.getElementById('size-guide-modal');
            if (modal) { modal.classList.remove('active'); modal.hidden = true; document.body.style.overflow = ''; }
          }
          try { found.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* ignore */ }
          found.classList.add('sg-flash');
          setTimeout(function () { found.classList.remove('sg-flash'); }, 1700);
        };
      } else {
        els.apply.hidden = true;
        if (els.applyMissing) {
          els.applyMissing.hidden = false;
          els.applyMissing.innerHTML = 'מידה ' + escapeHtml(rec) + ' לא קיימת במוצר זה, ' +
            '<a class="sg__wa-link" href="' + escapeAttr(data.whatsapp) +
            '" target="_blank" rel="noopener">דברו איתנו בוואטסאפ</a>';
        }
      }
    }

    function renderResult(res) {
      var cd = data.categories[activeCat];
      if (els.sizeEl) els.sizeEl.textContent = res.size;
      if (els.conf) {
        els.conf.classList.remove('sg__conf--high', 'sg__conf--medium', 'sg__conf--low');
        els.conf.classList.add('sg__conf--' + res.conf);
      }
      if (els.confText) {
        var ctext = res.conf === 'high' ? 'התאמה מצוינת' : (res.conf === 'medium' ? 'התאמה טובה' : 'כדאי להתייעץ איתנו');
        els.confText.textContent = ctext;
      }
      var sils = root.querySelectorAll('[data-sg-sil]');
      for (var i = 0; i < sils.length; i++) {
        sils[i].hidden = sils[i].getAttribute('data-sg-sil') !== cd.silhouette;
      }
      var recRow = cd.sizes[res.index];
      applyChip('chest', cd, recRow);
      applyChip('length', cd, recRow);
      renderSpecs(cd, recRow);
      renderNotes(res);
      reveal();
      highlightTable(activeCat, res.size);
      highlightCards(activeCat, res.size);
      if (ctx === 'modal') handleApply(res);
    }

    function onCalc() {
      var inputs = {
        height: getNum('height'),
        weight: getNum('weight'),
        age: getNum('age'),
        fit: getFit()
      };
      var res = recommend(data, activeCat, inputs);
      renderResult(res);
      saveLS(inputs, res);
    }

    function saveLS(inputs, res) {
      try {
        window.localStorage.setItem(LS_KEY, JSON.stringify({
          category: activeCat,
          height: inputs.height,
          weight: inputs.weight,
          age: inputs.age,
          fit: inputs.fit,
          lastRec: res.size,
          ts: Date.now()
        }));
      } catch (e) { /* storage blocked */ }
    }

    function prefillNum(name, val) {
      if (val === null || val === undefined || isNaN(parseFloat(val))) return;
      var num = q('[data-sg-num="' + name + '"]');
      var rng = q('[data-sg-range="' + name + '"]');
      if (num) num.value = val;
      if (rng) rng.value = val;
    }

    function prefill() {
      var saved = null;
      try {
        var raw = window.localStorage.getItem(LS_KEY);
        if (raw) saved = JSON.parse(raw);
      } catch (e) { saved = null; }

      if (ctx === 'modal') {
        try {
          var vt = document.getElementById('version-toggle');
          var pb = document.querySelector('.pdp2__seg-btn--player.active');
          if ((vt && vt.checked) || pb) setFit('player');
        } catch (e) { /* probe failed */ }
      }

      if (!saved) return;
      try {
        if (allowSwitch && saved.category && data.categories[saved.category]) {
          activeCat = saved.category;
          if (els.seg) {
            var all = els.seg.querySelectorAll('[data-sg-cat]');
            for (var i = 0; i < all.length; i++) {
              var on = all[i].getAttribute('data-sg-cat') === saved.category;
              if (on) { all[i].classList.add('is-active'); } else { all[i].classList.remove('is-active'); }
              all[i].setAttribute('aria-selected', on ? 'true' : 'false');
            }
          }
        }
        prefillNum('height', saved.height);
        prefillNum('weight', saved.weight);
        prefillNum('age', saved.age);
        if (saved.fit === 'player') setFit('player');
        else if (saved.fit === 'regular') setFit('regular');
      } catch (e) { /* prefill best-effort */ }
    }

    // Boot
    wireRanges();
    wireSteppers();
    wireFit();
    buildCards();
    if (els.calc) els.calc.addEventListener('click', onCalc);
    wireSeg();
    prefill();
    applyCategory(activeCat);
    positionInd();
    updateFills();

    /* ── Compact mode (data-sg-compact, V4 modal): LIVE recommendation - result updates as the
       sliders move, no "calculate" press. Tables+notes collapse behind [data-sg-more-toggle].
       Inert for roots without the attribute. ── */
    if (root.hasAttribute('data-sg-compact')) {
      var liveT = null;
      function liveCalc() {
        if (liveT) clearTimeout(liveT);
        liveT = setTimeout(function () {
          // mid-typing a cleared number field is NaN -> recommend() clamps to the largest size
          // with a scary out-of-range note; skip until there is a real value again
          if (isNaN(getNum('height'))) return;
          try { onCalc(); } catch (e) { /* keep modal usable */ }
        }, 140);
      }
      root.addEventListener('input', function (e) {
        if (e.target && (e.target.hasAttribute('data-sg-range') || e.target.hasAttribute('data-sg-num'))) liveCalc();
      });
      root.addEventListener('click', function (e) {
        if (e.target && e.target.closest('[data-sg-fit],[data-sg-cat],[data-sg-step]')) liveCalc();
      });
      var moreBtn = root.querySelector('[data-sg-more-toggle]');
      var moreBox = root.querySelector('[data-sg-more]');
      if (moreBtn && moreBox) {
        moreBtn.addEventListener('click', function () {
          var open = moreBox.hidden;
          moreBox.hidden = !open;
          moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          moreBtn.classList.toggle('is-open', open);
          if (open) { try { moreBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) { /* ignore */ } }
        });
      }
      liveCalc(); // first paint: recommendation visible immediately on open
    }
  }

  if (typeof window !== 'undefined') {
    if (window.__jrsSG) return;
    window.__jrsSG = { recommend: recommend, parseRange: parseRange };
    onReady(initAll);
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { recommend: recommend, parseRange: parseRange };
  }
})();
